module.exports =
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // define getter function for harmony exports

  /******/

  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      Object.defineProperty(exports, name, {
        /******/
        configurable: false,

        /******/
        enumerable: true,

        /******/
        get: getter
        /******/

      });
      /******/
    }
    /******/

  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = 85);
  /******/
}(
/************************************************************************/

/******/
{
  /***/
  0:
  /***/
  function _(module, exports) {
    module.exports = require("react");
    /***/
  },

  /***/
  1:
  /***/
  function _(module, exports) {
    module.exports = require("prop-types");
    /***/
  },

  /***/
  3:
  /***/
  function _(module, exports) {
    module.exports = require("classnames/bind");
    /***/
  },

  /***/
  85:
  /***/
  function _(module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });

    var _Badge = __webpack_require__(86);

    var _Badge2 = _interopRequireDefault(_Badge);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    exports.default = _Badge2.default;
    /***/
  },

  /***/
  86:
  /***/
  function _(module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });

    var _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    exports.default = Badge;

    var _react = __webpack_require__(0);

    var _react2 = _interopRequireDefault(_react);

    var _propTypes = __webpack_require__(1);

    var _propTypes2 = _interopRequireDefault(_propTypes);

    var _bind = __webpack_require__(3);

    var _bind2 = _interopRequireDefault(_bind);

    var _general = __webpack_require__(87);

    var _general2 = _interopRequireDefault(_general);

    var _color = __webpack_require__(88);

    var _color2 = _interopRequireDefault(_color);

    var _size = __webpack_require__(89);

    var _size2 = _interopRequireDefault(_size);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    var badgeColors = Object.keys(_color2.default);
    var badgeSizes = Object.keys(_size2.default);

    var badgeStyles = _extends({}, _general2.default, _color2.default, _size2.default);

    var cx = _bind2.default.bind(badgeStyles);

    function Badge(_ref) {
      var color = _ref.color,
          minWidth = _ref.minWidth,
          size = _ref.size,
          text = _ref.text;
      var badgeSize = {
        small: 16,
        medium: 20,
        large: 24
      };
      var badgeProps = {
        className: cx('badge', color, size),
        style: {
          height: badgeSize[size],
          minWidth: minWidth,
          lineHeight: badgeSize[size] + 'px',
          borderRadius: badgeSize[size] / 2
        }
      };
      return _react2.default.createElement('div', badgeProps, text);
    }

    Badge.propTypes = {
      color: _propTypes2.default.oneOf(badgeColors),
      minWidth: _propTypes2.default.number,
      size: _propTypes2.default.oneOf(badgeSizes),
      text: _propTypes2.default.string.isRequired
    };
    Badge.defaultProps = {
      color: 'blue',
      minWidth: 0,
      size: 'medium'
    };
    /***/
  },

  /***/
  87:
  /***/
  function _(module, exports) {
    // removed by extract-text-webpack-plugin
    module.exports = {
      "badge": "general__badge___TKkkh display-inlineBlock fontWeight-5 textAlign-center"
    };
    /***/
  },

  /***/
  88:
  /***/
  function _(module, exports) {
    // removed by extract-text-webpack-plugin
    module.exports = {
      "blue": "color__blue___2371e bg-blue c-white",
      "purple": "color__purple___KBMFo bg-purple c-white",
      "pink": "color__pink___1GDb4 bg-pink c-white",
      "orange": "color__orange___9Cbzt bg-orange c-white",
      "green": "color__green___3p-yh bg-green c-white",
      "yellow": "color__yellow___1hC-4 bg-yellow c-white",
      "red": "color__red___2EI3m bg-negative c-white",
      "ghost": "color__ghost___oiLLW bg-transparent boxShadow-smoke c-silver",
      "darkGhost": "color__darkGhost___3UxTd bg-transparent boxShadow-smoke--d c-silver",
      "white": "color__white___2jBBB bg-white c-slate",
      "darkGhostReversed": "color__darkGhostReversed___s-r6W bg-transparent boxShadow-white--transparent c-white"
    };
    /***/
  },

  /***/
  89:
  /***/
  function _(module, exports) {
    // removed by extract-text-webpack-plugin
    module.exports = {
      "small": "size__small___2gMpo fontSize-xxs paddingLeftRight-xxs",
      "medium": "size__medium___1apNm fontSize-xs",
      "large": "size__large___1oefV fontSize-m paddingLeftRight-xs"
    };
    /***/
  }
  /******/

});